import api from "@client/content/lib/api";
import { type ModuleApiInfo } from "@client/content/selectors";
import { type HttpApiResponse } from "@client/types/Api";
import { type CourseList } from "./types";

export default {
  getCourses: (
    apiInfo: ModuleApiInfo,
    args: CourseList.Api.GetCoursesRequest
  ): Promise<HttpApiResponse<CourseList.Api.GetCoursesResponse>> =>
    api.get(apiInfo, `/api/site/v1/modules/courses/list`, args)
};
